import React, { useMemo } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableFooter,
  TableHead,
  TableRow,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { darken, alpha, lighten } from '@mui/material/styles';
import * as eh from '../../helpers/event-helper';
import * as dh from '../../helpers/dates';
import TableTotalCell from './TableTotalCell';
import TableRowPlaceholder from './TableRowPlaceholder';

const useStyles = makeStyles(theme => ({
  rampTable: {
    height: '100%',
    borderLeft: `1px solid
    ${
      theme.palette.mode === 'light'
        ? lighten(alpha(theme.palette.divider, 1), 0.88)
        : darken(alpha(theme.palette.divider, 1), 0.68)
    }`,
    width: 'auto',
  },
  tableHead: {
    height: theme.typography.pxToRem(70),
  },
}));

const getRows = (events, rampServiceId) => {
  const rows = events.map(event => {
    let eventRampValues = eh.getRampServiceById(
      event.outbound.ramp,
      event.outbound.fixedRamp,
      rampServiceId
    );
    return {
      _id: event._id,
      amount: eventRampValues?.amount ?? '',
      startTime: dh.dateToTimeString(eventRampValues?.start),
      endTime: dh.dateToTimeString(eventRampValues?.end),
    };
  });
  return [
    rows.some(row => !!row.amount),
    eh.calcArrayPropertyTotal(rows, 'amount'),
    rows,
  ];
};

const RampServiceTable = ({ rampService, events, selectedRow, onRowClick }) => {
  const classes = useStyles();
  const [hasData, totalAmount, rows] = useMemo(() => {
    return getRows(events, rampService._id);
  }, [events, rampService]);
  if (!hasData) return null;

  return (
    <Table className={classes.rampTable} size="small" stickyHeader>
      <TableHead>
        <TableRow className={classes.tableHead}>
          <TableCell>{rampService.name}</TableCell>
          {rampService.isTimeBased && (
            <>
              <TableCell>Start Time</TableCell>
              <TableCell>End Time</TableCell>
            </>
          )}
        </TableRow>
      </TableHead>
      <TableBody>
        {!rows.length && <TableRowPlaceholder />}
        {rows.map(row => (
          <TableRow
            key={row._id}
            data-eventid={row._id}
            selected={row._id === selectedRow}
            onClick={onRowClick}
          >
            <TableCell>{row.amount}</TableCell>
            {rampService.isTimeBased && (
              <>
                <TableCell>{row.startTime}</TableCell>
                <TableCell>{row.endTime}</TableCell>
              </>
            )}
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableTotalCell>{totalAmount}</TableTotalCell>
          {rampService.isTimeBased && (
            <>
              <TableTotalCell />
              <TableTotalCell />
            </>
          )}
        </TableRow>
      </TableFooter>
    </Table>
  );
};

// {gpus.map(gpu => (
//     <RampTableRow key={gpu._id} service={gpu} />
//   ))}

export default React.memo(RampServiceTable);
